import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectActiveProducts } from '@paradigm/store/auth';

import {
  useRfqBuilderActions,
  useRfqBuilderView,
} from '@paradigm/features/src/unified-rfqs/ui';

import SelectField from '#/components/UnifiedRfqs/components/SelectField';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import { useTrackAction } from '@paradigm/features/src/analytics';
import { FormOption } from '@paradigm/features/src/unified-rfqs/ui/rfq-builder/types';
import { Source } from '@paradigm/features/src/unified-rfqs/entities/products/venue';

export default function VenueSelector() {
  const activeProducts = useSelector(selectActiveProducts);
  const { venue } = useRfqBuilderView();
  const activeVenues = venue.options.filter((v) =>
    activeProducts.includes(v.value),
  );
  const { selectVenue } = useRfqBuilderActions();
  const isMobile = useIsMobile();
  const trackAction = useTrackAction();

  const handleOnChange = useCallback(
    (option: FormOption<Source> | null) => {
      trackAction('update venue', { venueCode: option?.value ?? null });
      if (option != null) selectVenue(option.value);
    },
    [selectVenue, trackAction],
  );

  const selectedVenue = venue.selectedOption;

  return useMemo(
    () => (
      <SelectField
        aria-label="Select venue"
        options={activeVenues}
        value={selectedVenue}
        onChange={handleOnChange}
        isSearchable={!isMobile}
      />
    ),
    [activeVenues, handleOnChange, isMobile, selectedVenue],
  );
}
